module.exports = __webpack_public_path__ + "static/media/discord.d3626e84.png";